import { Row } from "react-flexbox-grid/lib/index";
import {
  Card,
  Paper,
  CardActionArea,
  CardContent,
  CardHeader,
  IconButton,
  Collapse
} from "@material-ui/core";

import ContainerDimensions from "react-container-dimensions";

import React, { useState } from "react";
import PropTypes from "prop-types";

import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import FormStatusTable from "./FormStatusTable";
import SearchFiltersRow from "./SearchFiltersRow";

import DetailsModal from "./DetailsModal";

const StatusLayout = props => {
  const [open, setOpen] = useState(true);
  return (
    <Card>
      <ContainerDimensions>
        <DetailsModal {...props} />
      </ContainerDimensions>

      <Paper>
        <CardActionArea
          disableRipple
          component="a"
          onClick={() => setOpen(!open)}
        >
          <CardHeader
            title="CTD Processing Status"
            action={
              <IconButton onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            }
          />
        </CardActionArea>
        <Collapse in={open}>
          <CardContent>
            <SearchFiltersRow {...props} />
          </CardContent>
        </Collapse>
        <CardContent>
          <Row center="xs">
            <ContainerDimensions>
              <FormStatusTable {...props} />
            </ContainerDimensions>
          </Row>
        </CardContent>
      </Paper>
    </Card>
  );
};

StatusLayout.propTypes = {
  onRefreshClick: PropTypes.func.isRequired
};

export default StatusLayout;
